import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "wage-slip-broadcast-dialog" }
const _hoisted_2 = { class: "wage-slip-broadcast-dialog__header" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "wage-slip-broadcast-dialog__body" }
const _hoisted_5 = { class: "wage-slip-broadcast-dialog__lead" }
const _hoisted_6 = {
  key: 0,
  class: "wage-slip-broadcast-dialog__past"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "wage-slip-broadcast-dialog__error"
}
const _hoisted_9 = { class: "wage-slip-broadcast-dialog__sum" }
const _hoisted_10 = {
  key: 1,
  class: "wage-slip-broadcast-dialog__sum-sent"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 3,
  class: "wage-slip-broadcast-dialog__sum-alert"
}
const _hoisted_13 = {
  key: 0,
  class: "wage-slip-broadcast-dialog__list wage-slip-broadcast-dialog__list--check"
}
const _hoisted_14 = { class: "wage-slip-broadcast-dialog__check" }
const _hoisted_15 = ["value", "disabled"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "wage-slip-broadcast-dialog__badge wage-slip-broadcast-dialog__badge--sent"
}
const _hoisted_18 = {
  key: 2,
  class: "wage-slip-broadcast-dialog__badge"
}
const _hoisted_19 = {
  key: 1,
  class: "wage-slip-broadcast-dialog__empty"
}
const _hoisted_20 = {
  key: 2,
  class: "wage-slip-broadcast-dialog__unmatched"
}
const _hoisted_21 = { class: "wage-slip-broadcast-dialog__unmatched-list" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 3,
  class: "wage-slip-broadcast-dialog__skipped"
}
const _hoisted_24 = { class: "wage-slip-broadcast-dialog__footer" }
const _hoisted_25 = { class: "wage-slip-broadcast-dialog wage-slip-broadcast-dialog--result" }
const _hoisted_26 = { class: "wage-slip-broadcast-dialog__header" }
const _hoisted_27 = { class: "wage-slip-broadcast-dialog__body" }
const _hoisted_28 = { class: "wage-slip-broadcast-dialog__result-summary" }
const _hoisted_29 = {
  key: 0,
  class: "wage-slip-broadcast-dialog__result-block"
}
const _hoisted_30 = { class: "wage-slip-broadcast-dialog__result-list" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  class: "wage-slip-broadcast-dialog__result-block"
}
const _hoisted_33 = { class: "wage-slip-broadcast-dialog__result-list" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 2,
  class: "wage-slip-broadcast-dialog__result-guide"
}
const _hoisted_36 = { class: "wage-slip-broadcast-dialog__footer" }

import { computed, ref } from 'vue';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import { wageMagamApi } from '@/services/api';
import { formatYearMonthLabel } from '@/composables/wage/useWageMagam';

type PreviewRow = { displayName: string; bizGubun?: string; reason?: string };
type MatchedRow = PreviewRow & {
  cayIdx: number;
  alreadySent?: boolean;
  sentAt?: string;
};
type ResultRow = { displayName: string; message?: string; bizGubun?: string };
type BroadcastLog = { sentAt?: string; sentCount?: number; sentByName?: string };
type PreviewData = {
  matchedCount: number;
  skippedCount: number;
  unmatchedCount: number;
  matched: MatchedRow[];
  skipped: PreviewRow[];
  unmatched: PreviewRow[];
  isClosed?: boolean;
  isFirstBroadcast?: boolean;
  lastBroadcast?: BroadcastLog | null;
  broadcastHistory?: BroadcastLog[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'WageSlipBroadcastButton',
  props: {
    isClosed: { type: Boolean },
    memberCode: {},
    yearMonth: {},
    bizGubun: {}
  },
  setup(__props: any) {

const formatBroadcastAt = (raw?: string) => {
  const s = String(raw || '').replace('T', ' ');
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
  if (!m) return s;
  return `${m[1]}년 ${parseInt(m[2], 10)}월 ${parseInt(m[3], 10)}일 ${m[4]}:${m[5]}`;
};

const props = __props;

const dialogOpen = ref(false);
const previewLoading = ref(false);
const sending = ref(false);
const previewError = ref('');
const preview = ref<PreviewData | null>(null);
const selectedCayIdxs = ref<number[]>([]);
const resultOpen = ref(false);
const resultSummary = ref('');
const resultFailed = ref<ResultRow[]>([]);
const resultUnmatched = ref<ResultRow[]>([]);

const yearMonthLabel = computed(() => formatYearMonthLabel(props.yearMonth));
const alreadySentCount = computed(
  () => (preview.value?.matched || []).filter((row) => row.alreadySent).length
);
const canSend = computed(() => selectedCayIdxs.value.length > 0 && !!props.isClosed);
const isFirstBroadcast = computed(() => !!preview.value?.isFirstBroadcast);
const lastBroadcast = computed(() => preview.value?.lastBroadcast || null);
const broadcastHistory = computed(() =>
  Array.isArray(preview.value?.broadcastHistory) ? preview.value.broadcastHistory : []
);
const resultHasIssue = computed(
  () => resultFailed.value.length > 0 || resultUnmatched.value.length > 0
);
const historyText = computed(() => {
  if (!preview.value) return `${yearMonthLabel.value} 임금명세서 발송 여부를 확인합니다.`;
  if (preview.value.isFirstBroadcast || !lastBroadcast.value?.sentAt) {
    return `${yearMonthLabel.value} 임금명세서는 처음 보내는 것입니다.`;
  }
  const when = formatBroadcastAt(lastBroadcast.value.sentAt);
  return `${yearMonthLabel.value} 임금명세서는 ${when}에 보낸 적이 있습니다.`;
});

const closeDialog = () => {
  if (sending.value) return;
  dialogOpen.value = false;
};

const loadPreview = async () => {
  previewLoading.value = true;
  previewError.value = '';
  preview.value = null;
  try {
    const res = await wageMagamApi.previewSlipBroadcast({
      mCode: props.memberCode,
      yearMonth: props.yearMonth,
      bizGubun: props.bizGubun,
    });
    if (!res.data?.success) {
      previewError.value = res.data?.message || '대상 확인에 실패했습니다.';
      return;
    }
    const data = res.data.data || {};
    preview.value = {
      matchedCount: Number(data.matchedCount || 0),
      skippedCount: Number(data.skippedCount || 0),
      unmatchedCount: Number(data.unmatchedCount || 0),
      matched: Array.isArray(data.matched) ? data.matched : [],
      skipped: Array.isArray(data.skipped) ? data.skipped : [],
      unmatched: Array.isArray(data.unmatched) ? data.unmatched : [],
      isClosed: !!data.isClosed,
      isFirstBroadcast: !!data.isFirstBroadcast,
      lastBroadcast: data.lastBroadcast || null,
      broadcastHistory: Array.isArray(data.broadcastHistory) ? data.broadcastHistory : [],
    };
    // 아직 못 받은 사람만 기본 체크 — 이미 받은 사람은 해제된 채로 열림
    selectedCayIdxs.value = (preview.value?.matched || [])
      .filter((row) => !row.alreadySent)
      .map((row) => row.cayIdx);
    if (!data.isClosed) {
      previewError.value = '임금 마감 후 발송할 수 있습니다.';
    }
  } catch (error: any) {
    previewError.value =
      error.response?.data?.message || error.message || '대상 확인에 실패했습니다.';
  } finally {
    previewLoading.value = false;
  }
};

const openDialog = () => {
  if (!props.isClosed || sending.value) return;
  if (!props.memberCode || !props.yearMonth || !props.bizGubun) {
    alert('시설·연월·사업구분 정보가 없습니다.');
    return;
  }
  dialogOpen.value = true;
  void loadPreview();
};

const submitSend = async () => {
  if (!canSend.value) return;
  sending.value = true;
  try {
    const res = await wageMagamApi.sendSlipBroadcast({
      mCode: props.memberCode,
      yearMonth: props.yearMonth,
      bizGubun: props.bizGubun,
      title: `${yearMonthLabel.value} 임금명세서`,
      targetCayIdxs: [...selectedCayIdxs.value],
    });
    if (!res.data?.success) {
      throw new Error(res.data?.message || '발송 실패');
    }
    const sent = Number(res.data.data?.sent || 0);
    const failed = Number(res.data.data?.failed || 0);
    const results = Array.isArray(res.data.data?.results) ? res.data.data.results : [];
    resultFailed.value = results.filter((r: ResultRow & { ok?: boolean }) => !r.ok);
    resultUnmatched.value = preview.value?.unmatched || [];
    resultSummary.value = failed
      ? `${sent}명 발송 완료 · ${failed}명 실패했습니다.`
      : `${sent}명에게 임금명세서를 발송했습니다.`;
    dialogOpen.value = false;
    resultOpen.value = true;
  } catch (error: any) {
    alert(error.response?.data?.message || error.message || '임금명세서 발송에 실패했습니다.');
  } finally {
    sending.value = false;
  }
};

const closeResult = () => {
  resultOpen.value = false;
  resultFailed.value = [];
  resultUnmatched.value = [];
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      variant: "flat",
      class: "toolbar-slip-send-btn",
      size: "small",
      disabled: !__props.isClosed || sending.value,
      title: __props.isClosed ? '요양보호사 앱으로 임금명세서를 발송합니다' : '임금 마감 후 발송할 수 있습니다',
      onClick: openDialog
    }, {
      default: _withCtx(() => [
        (sending.value)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              size: "14",
              class: "mdi-spin"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("mdi-loading", -1)
              ]))]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_icon, {
              key: 1,
              size: "14"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-send-outline", -1)
              ]))]),
              _: 1
            })),
        _cache[5] || (_cache[5] = _createTextVNode(" 임금명세서발송 ", -1))
      ]),
      _: 1
    }, 8, ["disabled", "title"]),
    _createVNode(_component_v_dialog, {
      modelValue: dialogOpen.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogOpen).value = $event)),
      "max-width": "480",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(LoadingOverlay, {
            show: previewLoading.value || sending.value,
            text: sending.value ? '발송 중...' : '대상 확인 중...'
          }, null, 8, ["show", "text"]),
          _createElementVNode("div", _hoisted_2, [
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "임금명세서 발송", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "wage-slip-broadcast-dialog__close",
              disabled: sending.value,
              "aria-label": "닫기",
              onClick: closeDialog
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ], 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", {
              class: _normalizeClass(["wage-slip-broadcast-dialog__history", { first: isFirstBroadcast.value }])
            }, _toDisplayString(historyText.value), 3),
            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "wage-slip-broadcast-dialog__ask" }, "임금명세서를 보내시겠습니까?", -1)),
            _createElementVNode("p", _hoisted_5, _toDisplayString(yearMonthLabel.value) + " 명세서를 소속 요양보호사 앱 채팅으로 보냅니다. 서류관리함에도 월별로 보관됩니다. ", 1),
            (broadcastHistory.value.length > 1)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(broadcastHistory.value, (row, idx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `${row.sentAt}-${idx}`
                    }, [
                      _createTextVNode(_toDisplayString(formatBroadcastAt(row.sentAt)) + " ", 1),
                      (row.sentCount)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, " · " + _toDisplayString(row.sentCount) + "명", 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (previewError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(previewError.value), 1))
              : (preview.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("p", _hoisted_9, [
                      _cache[10] || (_cache[10] = _createTextVNode(" 발송 대상 ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(preview.value.matchedCount), 1),
                      _cache[11] || (_cache[11] = _createTextVNode("명 ", -1)),
                      (preview.value.matchedCount)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[8] || (_cache[8] = _createTextVNode(" · 선택 ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(selectedCayIdxs.value.length), 1),
                            _cache[9] || (_cache[9] = _createTextVNode("명 ", -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      (alreadySentCount.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " · 발송완료 " + _toDisplayString(alreadySentCount.value) + "명 ", 1))
                        : _createCommentVNode("", true),
                      (preview.value.skippedCount)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, " · 급여 없음 " + _toDisplayString(preview.value.skippedCount) + "명", 1))
                        : _createCommentVNode("", true),
                      (preview.value.unmatchedCount)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " · 앱 미연결 " + _toDisplayString(preview.value.unmatchedCount) + "명 ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    (preview.value.matched.length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preview.value.matched, (row) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: row.cayIdx
                            }, [
                              _createElementVNode("label", _hoisted_14, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCayIdxs).value = $event)),
                                  type: "checkbox",
                                  value: row.cayIdx,
                                  disabled: sending.value
                                }, null, 8, _hoisted_15), [
                                  [_vModelCheckbox, selectedCayIdxs.value]
                                ]),
                                _createElementVNode("strong", null, _toDisplayString(row.displayName || '요양보호사'), 1),
                                (row.bizGubun)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(row.bizGubun), 1))
                                  : _createCommentVNode("", true),
                                (row.alreadySent)
                                  ? (_openBlock(), _createElementBlock("em", _hoisted_17, [
                                      _cache[12] || (_cache[12] = _createTextVNode(" 발송완료", -1)),
                                      (row.sentAt)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(" · " + _toDisplayString(formatBroadcastAt(row.sentAt)), 1)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_openBlock(), _createElementBlock("em", _hoisted_18, "미발송"))
                              ])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_19, " 해당 월 급여가 있는 소속 요양보호사가 없습니다. ")),
                    (preview.value.unmatched.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _cache[13] || (_cache[13] = _createElementVNode("p", { class: "wage-slip-broadcast-dialog__unmatched-title" }, " 급여는 있는데 앱에 연결되지 않아 발송에서 빠집니다. ", -1)),
                          _createElementVNode("ul", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preview.value.unmatched, (row, idx) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: `unmatched-${idx}`
                              }, [
                                _createTextVNode(_toDisplayString(row.displayName), 1),
                                (row.bizGubun)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, " · " + _toDisplayString(row.bizGubun), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]),
                          _cache[14] || (_cache[14] = _createElementVNode("p", { class: "wage-slip-broadcast-dialog__unmatched-guide" }, " 요양보호사가 같은 성명·휴대폰으로 앱에 가입한 뒤, 센터 앱 인사관리에서 「동기화」를 눌러 주세요. ", -1))
                        ]))
                      : _createCommentVNode("", true),
                    (preview.value.skipped.length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preview.value.skipped, (row, idx) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: `skip-${idx}`
                            }, _toDisplayString(row.displayName) + " · " + _toDisplayString(row.reason), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_v_btn, {
              variant: "text",
              class: "btn-close",
              disabled: sending.value,
              onClick: closeDialog
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode("취소", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_v_btn, {
              variant: "flat",
              class: "btn-save",
              disabled: sending.value || previewLoading.value || !canSend.value,
              onClick: submitSend
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode(" 보내기 ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: resultOpen.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((resultOpen).value = $event)),
      "max-width": "440",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _cache[19] || (_cache[19] = _createElementVNode("span", null, "발송 결과", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "wage-slip-broadcast-dialog__close",
              "aria-label": "닫기",
              onClick: closeResult
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", _hoisted_28, _toDisplayString(resultSummary.value), 1),
            (resultFailed.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _cache[20] || (_cache[20] = _createElementVNode("p", { class: "wage-slip-broadcast-dialog__result-label" }, "발송 실패", -1)),
                  _createElementVNode("ul", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultFailed.value, (row, idx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `fail-${idx}`
                      }, [
                        _createTextVNode(_toDisplayString(row.displayName), 1),
                        (row.message)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, " · " + _toDisplayString(row.message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (resultUnmatched.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _cache[21] || (_cache[21] = _createElementVNode("p", { class: "wage-slip-broadcast-dialog__result-label" }, "앱 미연결로 제외", -1)),
                  _createElementVNode("ul", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultUnmatched.value, (row, idx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `un-${idx}`
                      }, [
                        _createTextVNode(_toDisplayString(row.displayName), 1),
                        (row.bizGubun)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, " · " + _toDisplayString(row.bizGubun), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (resultHasIssue.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_35, " 빠진 사람은 앱 연결 또는 급여 확인 후 다시 발송해 주세요. 같은 달은 다시 보낼 수 있습니다. "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_v_btn, {
              variant: "flat",
              class: "btn-save",
              onClick: closeResult
            }, {
              default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                _createTextVNode("확인", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})